/* eslint-disable camelcase */
// import sample from '@sample/account/users.json'
import axios from '@axios'


export const state = {
    options: [],
    ips : [],
    currentPage: 1,
    perPage: 15,
    totalPages: 1,
    totalRecords: 0,
}

export const getters = {
    allOptions: (state) => state.options,
    GET_IPS: (state) => state.ips,
    currentPage: (state) => state.currentPage,
    perPage: (state) => state.perPage,
    totalPages: (state) => state.totalPages,
    totalTemplate: (state) => state.totalTemplate,
    totalRecords: (state) => state.totalRecords,
}


export const mutations = {

    CREATE_IP: (state, ips) => {
        state.ips.unshift(ip)
      },

    DELETE_IP: (state, ips) => {
    state.ips.unshift(ip)
    },

    GET_IPS: (state, data) => {
        state.ips = data.ip_addresses
      },
    GET_OPTIONS: (state, data) => {
        if (!data) return false
        state.options = data.options
    },
}

export const actions = {
    async getIPs({ commit }, params = {}) {
        let { _commit } = params;
        const response = await axios.get('/options/ip-whitelist', { params });
        if (response.status === 200) {
            commit("GET_IPS", response.data);
        }
    },

    async createIpWhitelist({ commit }, ip) {
        await axios.post('/options/ip-whitelist', ip).then((resp) => {
          if (resp.status === 201) {
            let ip = resp.data
            commit('GET_IPS', ip)
          }
        })
      },

    async deleteIpWhitelist({ commit }, ip) {
        const url = `/options/ip-whitelist?ip_address=${ip.ip_address}`;
        try {
          const resp = await axios.delete(url);
          if (resp.status === 204) {
            commit('GET_IPS', ip);
          }
        } catch (error) {
          console.error('Error deleting IP whitelist:', error);
        }
      },

    async createIpBlacklist({ commit }, ip) {
        await axios.post('/options/ip-blacklist', ip).then((resp) => {
          if (resp.status === 201) {
            let ip = resp.data
            commit('GET_IPS', ip)
          }
        })
      },

    async deleteIpBlacklist({ commit }, ip) {
        const url = `/options/ip-blacklist?ip_address=${ip.ip_address}`;
        try {
          const resp = await axios.delete(url);
          if (resp.status === 204) {
            commit('GET_IPS', ip);
          }
        } catch (error) {
          console.error('Error deleting IP blacklist:', error);
        }
      },


    async getIPsBlacklist({ commit }, params = {}) {
        let { _commit } = params;
        const response = await axios.get('/options/ip-blacklist', { params });
        if (response.status === 200) {
            commit("GET_IPS", response.data);
        }
    },
    
    async getOptions({ commit, dispatch }, param = []) {
        let parameter = ''
        if (param.length !== 0) {
            parameter = '?'
            param.forEach((element, index) => {
                if (index !== 0) {
                    parameter += `&options[]=${element}`
                } else {
                    parameter += `options[]=${element}`
                }

            })
        }
        return axios.get(`/options${parameter}`)
    }, async updateOptions({ commit, dispatch }, option = {}) {
        return axios.patch(`/options`, option)
    }, async resetDefaultOptions({ commit, dispatch }, option = []) {
        return axios.patch(`/options/restore-default`, {
            options: option
        })
    },

    async deleteIP({ dispatch }, ipId) {
        return axios.delete(`/options/ip-whitelist/${ipId}`)
            .then(() => {
                // Refresh the IP list after deletion
                dispatch('getIPs', { page: 1, perPage: 15 });
            });
    }
}

